import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=63d93e62&"
import script from "./EditMember.vue?vue&type=script&lang=ts&"
export * from "./EditMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports